import * as React from 'react';
import Chip from '@mui/material/Chip';

import { styled } from '@mui/material/styles';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import InfoIcon from '@mui/icons-material/Info';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import DoneIcon from '@mui/icons-material/Done';

const StyledChip = styled(Chip)(({ theme }) => ({
  justifyContent: 'left',
  '& .icon': {
    color: 'inherit',
  },
  '&.AGUARDANDO': {
    color: (theme.vars || theme).palette.info.dark,
    border: `1px solid ${(theme.vars || theme).palette.info.main}`,
  },
  '&.ACEITO': {
    color: (theme.vars || theme).palette.success.dark,
    border: `1px solid ${(theme.vars || theme).palette.success.main}`,
  },
  '&.EXPIRADA': {
    color: (theme.vars || theme).palette.warning.dark,
    border: `1px solid ${(theme.vars || theme).palette.warning.main}`,
  },
  '&.EXPIRED': {
    color: (theme.vars || theme).palette.warning.dark,
    border: `1px solid ${(theme.vars || theme).palette.warning.main}`,
  },
  '&.NEGADO': {
    color: (theme.vars || theme).palette.error.dark,
    border: `1px solid ${(theme.vars || theme).palette.error.main}`,
  },
  '&.CANCELADA': {
    color: (theme.vars || theme).palette.error.dark,
    border: `1px solid ${(theme.vars || theme).palette.error.main}`,
  },
  '&.CANCELADO': {
    color: (theme.vars || theme).palette.error.dark,
    border: `1px solid ${(theme.vars || theme).palette.error.main}`,
  },
  '&.BLOQUEADO': {
    color: (theme.vars || theme).palette.warning.dark,
    border: `1px solid ${(theme.vars || theme).palette.warning.main}`,
  },
  '&.ATIVO': {
    color: (theme.vars || theme).palette.success.dark,
    border: `1px solid ${(theme.vars || theme).palette.success.main}`,
  },
  '&.AGUARDANDO_VALIDACAO': {
    color: (theme.vars || theme).palette.info.dark,
    border: `1px solid ${(theme.vars || theme).palette.info.main}`,
  },
  '&.VALIDADO': {
    color: (theme.vars || theme).palette.success.dark,
    border: `1px solid ${(theme.vars || theme).palette.success.main}`,
  },
  '&.INVALIDADO': {
    color: (theme.vars || theme).palette.error.dark,
    border: `1px solid ${(theme.vars || theme).palette.error.main}`,
  },
  '&.RESTRICAO_AREA': {
    color: (theme.vars || theme).palette.warning.dark,
    border: `1px solid ${(theme.vars || theme).palette.warning.main}`,
  },
  '&.AVAILABLE': {
    color: (theme.vars || theme).palette.info.dark,
    border: `1px solid ${(theme.vars || theme).palette.info.main}`,
  },
  '&.ACCEPTED': {
    color: (theme.vars || theme).palette.success.dark,
    border: `1px solid ${(theme.vars || theme).palette.success.main}`,
  },
  '&.FINALIZADA': {
    color: (theme.vars || theme).palette.success.dark,
    border: `1px solid ${(theme.vars || theme).palette.success.main}`,
  },
  '&.CANCEL': {
    color: (theme.vars || theme).palette.error.dark,
    border: `1px solid ${(theme.vars || theme).palette.error.main}`,
  },
  '&.VALIDO': {
    color: (theme.vars || theme).palette.success.dark,
    border: `1px solid ${(theme.vars || theme).palette.success.main}`,
  },
  '&.INVALIDO': {
    color: (theme.vars || theme).palette.neutral[600],
    border: `1px solid ${(theme.vars || theme).palette.neutral[400]}`,
  },
}));

const Status = React.memo((props) => {
  const { status, label } = props;

  let icon = null;
  if (status === 'NEGADO' || status === 'CANCELADA' || status === 'CANCELADO' || status === 'INVALIDADO') {
    icon = <ReportProblemIcon className="icon" />;
  } else if (status === 'AGUARDANDO' || status === 'AGUARDANDO_VALIDACAO') {
    icon = <InfoIcon className="icon" />;
  } else if (status === 'EXPIRADA' || status === 'EXPIRED' || status === 'BLOQUEADO') {
    icon = <AutorenewIcon className="icon" />;
  } else if (status === 'ACEITO' || status === 'VALIDADO' || status === 'ATIVO' || status === 'ACCEPTED' || status === 'VALIDO' || status === 'FINALIZADA') {
    icon = <DoneIcon className="icon" />;
  } else if (status === 'AVAILABLE') {
    icon = <InfoIcon className="icon" />;
  } else if (status === 'CANCEL') {
    icon = <ReportProblemIcon className="icon" />;
  } else if (status === 'RESTRICAO_AREA') {
    icon = <ReportProblemIcon className="icon" />;
  } else if (status === 'INVALIDO') {
    icon = <ReportProblemIcon className="icon" />;
  }

  return (
    <StyledChip
      className={status}
      icon={icon}
      size="small"
      label={label || status}
      variant="outlined"
    />
  );
});

export function renderStatus(params) {
  if (params.value == null) {
    return '';
  }

  return <Status status={params.value} label={params.label} />;
}